import React from "react";
import { Spinner } from "react-bootstrap";
import "./Loader.css";

const Loader = ({
  fullPage = false,
  overlay = false,
  message = "Loading...",
  size = "md",
}) => {
  const content = (
    <div className={`kior-loader ${fullPage ? "kior-loader--full" : ""} ${overlay ? "kior-loader--overlay" : ""}`}>
      <div className="kior-loader__inner">
        <Spinner animation="border" role="status" className="kior-loader__spinner" />
        {message ? <p className="kior-loader__text">{message}</p> : null}
      </div>
    </div>
  );

  return content;
};

export default Loader;
